import { createAction } from '@reduxjs/toolkit';

export const DECLINE_VIDEO_ACTION_TYPE = 'saga/declineVideo';
export const declineVideoAction = createAction(DECLINE_VIDEO_ACTION_TYPE);
